import {
  NXGDSNotificationPosition,
  NXGDSNotificationVisualType,
  type NXGDSNotificationProps,
} from "@nsftx/seven-nxg-design-system-backoffice";

export const DEFAULT_NOTIFY_POSITION = NXGDSNotificationPosition.BottomCenter;

export const NOTIFY_DEFAULTS: Pick<
  NXGDSNotificationProps,
  "type" | "position" | "timeDuration" | "closable"
> = {
  type: NXGDSNotificationVisualType.Toast,
  position: DEFAULT_NOTIFY_POSITION,
  timeDuration: 5,
  closable: true,
};
